import React from "react";
import { fileUrl } from "@/lib/api";

const COLORS = ["bg-terracotta", "bg-forest-700", "bg-gold", "bg-forest-500"];

export function Avatar({ user, size = 48, className = "" }) {
  const src = fileUrl(user?.picture);
  const name = user?.name || "?";
  const initials = name.split(" ").map((n) => n[0]).slice(0, 2).join("").toUpperCase();
  const color = COLORS[(name.charCodeAt(0) || 0) % COLORS.length];
  return src ? (
    <img
      src={src}
      alt={name}
      style={{ width: size, height: size }}
      className={`rounded-full object-cover border-2 border-white shadow-sm ${className}`}
    />
  ) : (
    <div
      style={{ width: size, height: size, fontSize: size * 0.4 }}
      className={`rounded-full ${color} text-white font-bold font-head flex items-center justify-center border-2 border-white shadow-sm ${className}`}
    >
      {initials}
    </div>
  );
}
